@if (isMenu) {
  <button mat-menu-item>
    <div class="item-menu-center">
      <span class="material-symbols-outlined"> delete </span>
      <span>{{ 'delete' | translate }}</span>
    </div>
  </button>
} @else {
  <button
    mat-icon-button
    [attr.aria-label]="'delete' | translate"
    matTooltip="{{ 'delete' | translate }}">
    <span class="material-symbols-outlined"> delete </span>
  </button>
}
